import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-global flex justify-between items-center relative" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "card-global mt-9 space-y-8" }
const _hoisted_4 = { class: "flex-grow bg-gray-50 rounded-lg p-3 border border-gray-100" }
const _hoisted_5 = {
  key: 0,
  class: "entity-details bg-white divide-y"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 p-2 capitalize text-left text-gray-400" }, "ID", -1)
const _hoisted_8 = { class: "flex-1 min-w-0 p-2 text-left" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_11 = { class: "flex-1 p-2 text-left" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_14 = { class: "flex-1 p-2 text-left" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_17 = { class: "flex-1 p-2 text-left" }

import BackButton from "@/components/common/BackButton.vue";
import { computed, ref } from "vue";
import { onMounted } from "vue";
import Nomenclature from "@/types/documents/nomenclature/Nomenclature";
import { useRoute } from "vue-router";
import StatusLabel from "@/components/common/StatusLabel.vue";
import PublicId from "@/components/common/PublicId.vue";
import { NomenclatureGetters } from "@/store/modules/nomenclature/getters";
import { NomenclatureActions } from "@/store/modules/nomenclature/actions";
import { useStore } from "vuex";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();

const nomenclature = ref<Nomenclature>();

onMounted(async () => {
  await store.dispatch(NomenclatureActions.FETCH_ONE, route.params.id);
  nomenclature.value = store.getters[NomenclatureGetters.GET_CURRENT];
});

const nomenclatureDetails = computed(
  () =>
    new Map([
      [t("common.id"), nomenclature.value?.id],
      [t("common.title"), nomenclature.value?.name],
      [t("common.index"), nomenclature.value?.index],
      [t("common.status"), nomenclature.value?.status],
    ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'NomenclatureList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("nomenclatureDetails.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (nomenclature.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(PublicId, {
                    value: nomenclature.value.id
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("common.title")), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(nomenclature.value.name), 1)
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)("common.index")), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(nomenclature.value.index), 1)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)("common.status")), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(StatusLabel, {
                    label: nomenclature.value.status
                  }, null, 8, ["label"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})